import { businessConfig } from "../content/siteContent";
import { useLanguage } from "./LanguageProvider";

export function SiteFooter() {
  const { copy } = useLanguage();
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <a href="#top" className="wordmark wordmark-footer" aria-label="Luma Care home">
            <span className="wordmark-mark" aria-hidden="true">L</span>
            <span><strong>Luma</strong> Care</span>
          </a>
          <p>{copy.footer.tagline}</p>
        </div>
        <div>
          <p className="footer-label">{copy.nav.services}</p>
          <a href={businessConfig.bookingUrl} target="_blank" rel="noreferrer">{copy.common.book}</a>
          <a href={`sms:${businessConfig.phoneDigits}`}>{copy.common.text}</a>
        </div>
        <div>
          <p className="footer-label">{copy.footer.bookingNote}</p>
          <p>© {new Date().getFullYear()} {copy.footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
